<gnx-top-nav [activeMiniApp]="MiniApps.AnalysisTool" />
<router-outlet />
